module.exports = __webpack_public_path__ + "media/images/admin/icons/check-circle-fc206c2b3a24c4ad59aca1c8267ee8d5.svg";